import React from 'react';
export const CTASection = () => {
  return <section className="w-full py-16 bg-gray-900 text-white" data-id="element-52">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-53">
        <div className="mb-8" data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-55">
            OSTATNIA SZANSA NA URATOWANIE TWOJEGO MAŁŻEŃSTWA
          </h2>
          <p className="text-xl mb-8" data-id="element-56">
            Tylko dziś w tej cenie - jutro wracamy do regularnej ceny 39,99 zł
          </p>
        </div>
        <a href="https://sklep.veiramode.com/products/od-frustracji-do-sily-psychologiczny-przewodnik-przez-kryzys-malzenski" className="bg-red-600 hover:bg-red-700 text-white text-xl md:text-2xl font-bold py-4 px-8 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 animate-pulse inline-block" data-id="element-57">
  RATUJ MAŁŻEŃSTWO → ODBIERZ ZA 29,99 ZŁ
      </a>
        <div className="mt-8 flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-8" data-id="element-58">
          <div className="flex items-center justify-center" data-id="element-59">
            <span className="text-yellow-400 mr-2" data-id="element-60">⚡</span>
            <span data-id="element-61">Natychmiastowy dostęp</span>
          </div>
          <div className="flex items-center justify-center" data-id="element-62">
            <span className="text-yellow-400 mr-2" data-id="element-63">⚡</span>
            <span data-id="element-64">Bezpieczna płatność BLIK/karta</span>
          </div>
          <div className="flex items-center justify-center" data-id="element-65">
            <span className="text-yellow-400 mr-2" data-id="element-66">⚡</span>
            <span data-id="element-67">30-dniowa gwarancja zwrotu pieniędzy - bez pytań</span>
          </div>
        </div>
        <div className="mt-12 bg-red-700/50 p-4 rounded-lg inline-block" data-id="element-68">
          <p className="text-lg" data-id="element-69">
            <span className="font-bold" data-id="element-70">UWAGA:</span> Tylko 17 egzemplarzy w
            promocji!
          </p>
        </div>
      </div>
    </section>;
};